import { Card, CardBody, Flex, Text } from '@backstage/ui';

import { PassFailBar } from '../SegmentedBar/SegmentedBar';
import styles from './EntityScorecardsTab.module.css';

interface OverallCardProps {
  pct: number;
  passing: number;
  failing: number;
  total: number;
  lastRunIso: string | undefined;
}

export const OverallCard = ({
  pct,
  passing,
  failing,
  total,
  lastRunIso,
}: OverallCardProps) => (
  <Card style={{ flex: 1 }}>
    <CardBody>
      <Text
        as="p"
        variant="body-small"
        color="secondary"
        weight="bold"
        className={styles.sectionLabel}
      >
        Overall
      </Text>
      <Flex align="center" gap="4" className={styles.overallStats}>
        <Text as="span" variant="title-large">
          {pct}%
        </Text>
        <Text as="span" variant="body-small" color="secondary">
          {passing} / {total} passing
        </Text>
      </Flex>
      <PassFailBar passing={passing} failing={failing} total={total} />
      {lastRunIso && (
        <Text
          as="p"
          variant="body-small"
          color="secondary"
          className={styles.lastRun}
        >
          Last run: {new Date(lastRunIso).toLocaleString()}
        </Text>
      )}
    </CardBody>
  </Card>
);
